<template>
  
  <div class="container">
  
    <Cabecera></Cabecera>
    <b-breadcrumb>
    <b-breadcrumb-item href="#"><router-link to="/">Inicio</router-link></b-breadcrumb-item>
    <b-breadcrumb-item href="#"><router-link to="/menuinicial">Inicio Usuario </router-link></b-breadcrumb-item>
    <b-breadcrumb-item href="#"><router-link to="/RegistrarVehiculos">Registro de Vehículos</router-link></b-breadcrumb-item>
    
  </b-breadcrumb>
  <div id="prueba">
  <Menu/>
    
  <b-card>
    
   <br>

        
          <span class="card-title">Registro de vehículos</span>
          <div>

            <div>
    <div
      class="imagePreviewWrapper"
      :style="{ 'background-image': `url(${previewImage})` }"
      @click="selectImage">
    </div>

    <input
      ref="fileInput"
      type="file"
      @input="pickFile">
  </div>

<input type="file" v-on:change=previewFile()><br>

<img id='Img1' :src="srcimg" height="200" alt="Image preview...">
<img id='Img2' src="../assets/credencial-4.png" height="200" alt="Image preview...">

  <button @click="exportPDF">Export PDF</button>
  <qrcode-vue id='idQR' class='codigoQR' :value="'https://micomidasegura.mx/#/registrarFlujoQR/'" :size="size" level="H" renderAs='canvas' background='#ffffff' foreground='#000000'></qrcode-vue>
  
    <span id='QRcodegenerator'>
<input type='text' :value="qrText" v-on:click=generateQrCode() > 
 <img :src="qrSrc">
    </span>
  <canvas id='canvas'>
    
   </canvas>
   <img id='img'>
    
</div>
          <form id="formPeso" autocomplete="off" @submit.prevent="editar" enctype="multipart/form-data">
            <input type="text" placeholder="Unidad" :value=unidad required disabled>
             <input type="date" name="fecharegistro" id="fecharegistro" placeholder="Fecha" v-on:click=usuario() required>
             <input type="text" name="placas" id="placas" placeholder="Placas del vehículo" required>
             <input type="text" name="nombre" id="nombre" placeholder="Nombre del titular" required>
             <input type="text" name="apellidos" id="apellidos" placeholder="Apellidos del titular" required>

             <b-form-select v-model="selected2" class="mb-3" required>
                <template v-slot:first>
        <b-form-select-option :value="null" disabled  >-- Selecciona el tipo --</b-form-select-option>
      </template>
      <b-form-select-option value="Carga">Carga</b-form-select-option>
      <b-form-select-option value="Estacionamiento">Estacionamiento</b-form-select-option>
      <b-form-select-option value="Descarga">Descarga</b-form-select-option>
      <b-form-select-option value="Proveedor">Proveedor</b-form-select-option>
     
    </b-form-select>

    <input type="text" name="otro" id="otro" placeholder="Otro tipo">
    
    <b-form-checkbox-group
      v-model="selected"
      :options="options"
      class="mb-3"
      value-field="item"
      text-field="name"
      disabled-field="notEnabled"
    ></b-form-checkbox-group>

    <input type="hidden" name="dias" id="dias" placeholder="dias" v-model="selected">
    
    Hora de entrada (00:00 am/pm)<input type="time" name="horaentrada" id="horaentrada" placeholder="Hora de entrada autorizada" required>
    Hora de salida (00:00 am/pm)<input type="time" name="horasalida" id="horasalida" placeholder="Hora de salida autorizada" required>
    <input type="text" name="area" id="area" placeholder="Área autorizada" required>
    <input type="text" name="gafete" id="gafete" placeholder="Clave distintivo" required>
    <input type="text" name="telefono" id="telefono" placeholder="Teléfono de contacto" required>

    
    

             
       <div class="file-field input-field">
                <div class="btn">
                <span>Evidencia</span>
                <input id='234' type="file" name="evidencia">
                </div>
                <div class="file-path-wrapper">
                <input id='123' class="file-path validate" type="text">
                </div>
                <div id="preview">
    <img v-if="url" :src="url" />
  </div>
            </div>      

    
            <input type="hidden" name="unidadForma" id="unidadForma" :value=unidad> 
            
             <input type="hidden" name="usuarioForma" id="usuarioForma" :value=usuariolocal>
             <input type="hidden" name="tipo" id="tipo" :value=selected2>
             
             <input type="hidden" name="idForma" id="idForma" :value=idActual>
             <input type="hidden" name="serieForma" id="serieForma" :value=serie>
             <input type="hidden" name="canalForma" id="canalForma" :value=canal>
             <input type="hidden" name="seccionForma" id="seccionForma" :value=seccion>
            
<div class="card-action">

                        <input type="submit" value="Registrar" class="btn btn-outline-success" required >
                           
        </div>
            </form>
       
    <b-card-body class="text-center">
      <b-card-title>Pantalla de inicio</b-card-title>

      <b-card-text>
       <div>
    <h5>Listado del día <input width="4" type="date" name="fechadia" id="fechadia" placeholder="Fecha" v-on:click=ajax() >
<p id="datetime"></p>
    </h5>
   <vue-good-table
   :columns="columns"
     :rows="rows"
     @on-cell-click="onCellClick2"
     
     :pagination-options="{
       enabled:true,
      
       mode:'remote',
       perPage:350,
       position:'top',
       perPageDropdown:[10,50,100],
       nextLabel:'Siguiente',
       PrevLabel:'Anterior',
       rowsPerPageLabel:'Filas por página',
       ofLabel:'de'
     }"
     :search-options="{
       enabled:true,
       trigger:'enter',
       placeholder:'Buscar'
     }"
   >
     <template slot="table-row" slot-scope="props">
          
    <span v-if="props.column.field == 'eliminar'">
       <b-button variant="outline-danger">Eliminar</b-button>
    </span>
    <span v-else-if="props.column.field == 'codigo'">
       <qrcode-vue id='codigo' class='codigoQR' :value="'https://micomidasegura.mx/#/registrarFlujoQR/'+props.formattedRow['gafete']" 
       :size="size" level="H" renderAs='svg' background='#ffffff' foreground='#000000'></qrcode-vue>
    </span>
    <span v-else>
      {{props.formattedRow[props.column.field]}}
    </span>
  </template>
   </vue-good-table>
</div>
      </b-card-text>

      <b-button variant="primary">Go somewhere</b-button>
    </b-card-body>
  </b-card>
</div>

    
  </div>
</template>

<script>
import Cabecera from './Cabecera' //v-on:keyup.enter="onEnter"
import Menu from './Menu'
import axios from 'axios'
import swal from 'sweetalert'
import sesion from '../mixins/sesion'
import QrcodeVue from 'qrcode.vue'
import qrCode from 'qrcode'
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from 'vue-qrcode-reader'
import eliminarDecomisos from '../mixins/eliminarDecomisos'
import {mapState, mapMutations, mapActions, mapGetters} from 'vuex'
import jsPDF from 'jspdf'
export default {
  name: 'Prueba',  
  data () {
    return {
        value:null,
      msg: 'Número de arete',
      inventarioCanales:{},
      usuariolocal:'',
      fotolocal:'',
      unidad:'',
        fecha1:'',
        fecha2:'',
        serie:'',
        canal:'',
        seccion:'',
        size:100,
        canvas:'',
        context:'',
        img:'',
        qrText: 'hola',
        srcimg:'',
        previewImage: null,
        url:null,
      qrSrc: null,
      blob2:null,
      blobtest:'',
      img3:null,
      //img:null,
selected: [],
todos: [
        {title: 'todo 1', description: 'description 1'},
        {title: 'todo 2', description: 'description2'},
        {title: 'todo 3', description: 'description 3'},
        {title: 'todo 4', description: 'description 4'},
        {title: 'todo 5', description: 'description 5'}
      ],
        options: [
          { item: '2', name: 'Lunes' },
          { item: '3', name: 'Martes' },
          { item: '4', name: 'Miércoles' },
          { item: '5', name: 'Jueves' },
          { item: '6', name: 'Viernes' },
          { item: '7', name: 'Sábado' },
          { item: '1', name: 'Domingo' },
        ],
selected2: null,
selectedCanal:null,
diasautorizados:null,
//Datos del checkbox
      columns:[
        {
          label:'Gafete',
          field:'gafete'
        },
        {
          label:'Id',
          field:'id',
          hidden: true
        },
        {
          label:'Placas',
          field:'placas',
        },
        {
          label:'Nombre',
          field:'nombre'
        },
        {
          label:'Apellidos',
          field:'apellidos'
        },
        {
          label:'Código',
          field:'codigo',
        },
        {
          label:'Eliminar',
          field:'eliminar',
        },
      ],
      rows:[

      ],

      
    }
    },
  
  computed:{
      ...mapState(['usuarioActual','idActual','fotoActual'])
  },
  methods:{
      onFileChange(e) {
      const file = e.target.files[0];
      this.url = URL.createObjectURL(file);
    },
 selectImage () {
          this.$refs.fileInput.click()
      },
      pickFile () {
        let input = this.$refs.fileInput
        let file = input.files
        if (file && file[0]) {
          let reader = new FileReader
          reader.onload = e => {
            this.previewImage = e.target.result
          }
          reader.readAsDataURL(file[0])
          this.$emit('input', file[0])

        
        }
      },     
  previewFile() {
  console.log(document.getElementById('123').value+document.getElementById('234').value);
  //var preview = document.querySelector('canvas');
var preview = document.querySelector('img');
  var file    = document.querySelector('input[type=file]').files[0];
 // var file    = document.querySelector('https://micomidasegura.mx/comidaSegura/api/crud/foto_perfil/FotoReemo673730.jpg').files[0];
  let link = document.createElement('a');
        link.download = 'hello.jpg';
  
  var reader  = new FileReader();

  reader.onloadend = function () {
    preview.src = reader.result;
  }

  if (file) {
    reader.readAsDataURL(file);
   
  } else {
    preview.src = "";
  }
  const blob3 = new Blob([file],{type: 'image/png'})
function blobToDataURL(blob, callback) {
    var a = new FileReader();
    a.onload = function(e) {callback(e.target.result);}
    a.readAsDataURL(blob);
    
}
  
this.blobtest=blobToDataURL(blob3, function(dataurl){
    //this.blobtest=dataurl
    console.log(dataurl);
})


  
console.log( 'data:image/jpeg;base64,'+'sí se pudo img3')
var vase64='data:image/jpeg;base64,'+ blob3

//var imgData = 'data:image/jpeg;base64,'+ Base64.encode('Koala.jpeg')
  /*
  //reader.readAsDataURL(file);


  reader.onload = function() {
        link.href = reader.result; // data url

     
 var doc = new jsPDF({
  orientation: 'landscape',
  //unit: 'in',
  //format: [80, 40]
  format: 'letter'
})

doc.text('Hello world!', 10, 10)
//doc.addImage(imgData2, 'JPEG', 15, 40, 100, 100)
doc.addImage(link.href, 'JPEG', 15, 40, 100, 100)
doc.save('two-by-four.pdf')
        link.click();
}

*/

var c=document.createElement('canvas')
var img = document.getElementById('Img2')
var img10 = document.getElementById('Img1')

/*var img = new Image,
    canvas = document.createElement("canvas"),
    ctx = canvas.getContext("2d"),
    src = "../assets/credencial-2.png";*/
//var img = preview.src;
var c=document.createElement('canvas')
var img = document.getElementById('Img2')
c.height=img.naturalHeight
c.width=img.naturalWidth
var ctx = c.getContext('2d')
console.log(img+'sí se pudo img34')
ctx.drawImage(img,0,0,c.width,c.height)
var base64String=c.toDataURL()


    //src = this.srcimg; // insert image url here

//img.crossOrigin = "Anonymous";
/*
img.onload = function() {
    canvas.width = img.width;
    canvas.height = img.height;
    ctx.drawImage( img, 0, 0 );
    localStorage.setItem( "savedImageData", canvas.toDataURL("image/png") );
}
img.src = src;
// make sure the load event fires for cached images too
if ( img.complete || img.complete === undefined ) {
    img.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
    img.src = src;
}
*/
var doc = new jsPDF({
  orientation: 'landscape',
  //unit: 'in',
  //format: [80, 40]
  format: 'letter'
})

doc.text('Hello world!', 10, 10)
//doc.addImage(imgData2, 'JPEG', 15, 40, 100, 100)
doc.addImage(base64String, 'JPEG', 0, 40, 100, 100)
//doc.addImage(this.blobtest, 'PNG', 0, 40, 100, 100)
doc.setDrawColor(0)
doc.setFillColor(255, 255, 255)
doc.roundedRect(140, 20, 10, 10, 3, 3, 'FD')
doc.save('two-by-four.pdf')
        link.click();

/*vomienzo
  let img = document.querySelector('img');

// make <canvas> of the same size
let canvas = document.createElement('canvas');
canvas.width = img.clientWidth;
canvas.height = img.clientHeight;

let context = canvas.getContext('2d');

// copy image to it (this method allows to cut image)
//context.drawImage(img, 0, 0);
// we can context.rotate(), and do many other things on canvas

// toBlob is async opereation, callback is called when done
canvas.toBlob(function(blob) {
  // blob ready, download it
  let link = document.createElement('a');
  link.download = 'example.png';

  link.href = URL.createObjectURL(blob);
  link.click();

  // delete the internal blob reference, to let the browser clear memory from it
  URL.revokeObjectURL(link.href);
}, 'image/png');*/
URL.revokeObjectURL(link.href);
},
    createObjectUrl (err, canvas) {
        var file    = document.querySelector('input[type=file]').files[0];
        
      if (!err) {
        canvas.toBlob((blob) => {
          //this.qrSrc = window.URL.createObjectURL(blob)
          this.qrSrc = window.URL.createObjectURL(file)
         // this.qrSrc = document.URL.createObjectURL(blob)
         this.blob2=blob
         console.log(this.blob2.type +'sí se pudo')
         console.log(blob.type +'sí se pudo')
          /*
var canvas = document.createElement("canvas");
  canvas.width = img.width;
  canvas.height = img.height;
  var ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0);
  var dataURL = canvas.toDataURL("image/png");
  return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
*/
 
         let link = document.createElement('a');
        link.download = 'hello.png';
         let reader = new FileReader();
        reader.readAsDataURL(blob);
        //this.blob2=window.URL.createObjectURL(file)
        //reader.readAsDataURL();
        //reader.readAsDataURL();
        //reader.readAsText(file)
        reader.onload = function() {
        link.href = reader.result; // data url

     
 var doc = new jsPDF({
  orientation: 'landscape',
  //unit: 'in',
  //format: [80, 40]
  format: 'letter'
})

doc.text('Hello world!', 10, 10)
//doc.addImage(imgData2, 'JPEG', 15, 40, 100, 100)
doc.addImage(link.href, 'JPEG', 15, 40, 100, 100)
//doc.addImage(blob2, 'JPEG', 15, 40, 100, 100)
doc.save('two-by-four.pdf')
        link.click();
}
        console.log(reader+'sí se pudo href')
      
        })
        console.log(img2.type +'sí se pudo img')
      } else {
        console.warn('generateQrCode:ERROR', err)
      }
    },
    generateQrCode () {
      //if (!this.qrText) { return }
      //document.URL.revokeObjectURL(this.qrSrc)
      window.URL.revokeObjectURL(this.qrSrc)
      qrCode.toCanvas(this.qrText, {}, this.createObjectUrl)
    },
    
    exportPDF() {
      // console.log( document.getElementById('img1').type +'sí se pudo img34')
  this.canvas = document.getElementById('canvas');
  this.context = this.canvas.getContext('2d');

  this.context.fillStyle = 'red';
  this.context.fillRect(10, 10, 20, 40);

  this.context.fillStyle = 'rgba(0,0,255,0.7)';
  this.context.fillRect(20, 20, 40, 20);
  
  


this.img = document.getElementById('img');
  this.img.src = this.canvas.toDataURL();

  
  console.log(img.src);

   canvas.toBlob(function(blob) {
    console.log(blob.type);
    console.log(blob.size);})
 /*     var pdfFileName = 'file.pdf';
var element = document.getElementById('idQR');
const options = {
    margin: 1,
    filename: pdfFileName,
    image: {
        type: 'jpeg',
        quality: 0.98
    },
    html2canvas: {
        dpi: 192,
        letterRendering: true
    },
    jsPDF: {
        unit: 'in',
        format: 'letter',
        orientation: 'portrait'
    }
}

html2pdf(element, options);*/

      var doc = new jsPDF({


  orientation: 'landscape',
  //unit: 'in',
  //format: [80, 40]
  format: 'letter'
})
var elementHTML = document.getElementById('prueba')
var specialElementHandlers = {
    '#elementH': function (element, renderer) {
        return true;
    }
};
doc.fromHTML(elementHTML, 15, 15, {
    'width': 170,
    'elementHandlers': specialElementHandlers
});
doc.text('Hello world!', 10, 10)

doc.addImage(this.img, 'PNG', 15, 40, 100, 100)
doc.save('two-by-four.pdf')
    },
      setDia(){
          this.dias=selected
      },
      getInventario(){
          const unidadInv = this.unidad
            
            axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getInventario.php?unidad='+ unidadInv)
            
                .then(response=>{
                   
                    this.inventarioCanales=response.data
                    
                })
      },
    getId(){
           this.usuario()

            const id = document.getElementById("usuarioForma").value
            
            axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getPerfilUsuario.php?id='+ id)
            
                .then(response=>{
                   
                    this.unidad = response.data.unidad
                    this.usuariolocal=response.data.email
                    
                })        
        },

    
  onCellClick2(params) {
         if(params.column.field=="eliminar"){   //que sea solo en esas columnas y que se refresque
         this.serie=params.row.serie
         this.canal=params.row.id
         this.seccion=params.row.seccion
         
         swal({
            title:'Seguro que deseas eliminar el registro',
            text:'',
            icon:'warning',
            buttons:true,
            dangerMode:true,
        })
        .then((aceptar)=>{
            if(aceptar){
            const form=params.row.id
                axios.post('https://micomidasegura.mx/comidaSegura/api/crud/eliminarVehiculos.php?id=' + form)
                .then(res=>{
                    this.respuesta = res.data
                    if (res.data == 'success') {
                        this.ajax()
         
                      swal('Se registro fue eliminado')
                       //location.reload()
                        //this.$router.push('/inicio')
                    } else {
                        swal('El registro no fue eliminado')
                    }
                })
            }else{
                return false;
            }
        })
         this.ajax()
        
         
         }
  },
      /*onEnter: function() {
      swal("Mensaje de enter")
    },*/
    fecha(){
        var dt = new Date();
    document.getElementById("datetime").innerHTML = ((dt.getFullYear() +"-"+ (("0"+(dt.getMonth()+1)).slice(-2)) 
    +"-"+ ("0"+dt.getDate()).slice(-2)));
    },
    ajax(){
     //const fecha = JSON.parse(document.getElementsByName('fecharegistro').value)
     this.getId()
    const fecha = document.getElementById("fechadia").value
     const unidadquery=this.unidad
      axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getVehiculos.php?unidad='+unidadquery)
      .then(response=>{
        this.rows=response.data
      })

    },

    
    usuario(){
        this.fecha()
     //const fecha = JSON.parse(document.getElementsByName('fecharegistro').value)
     var yourString = this.$localStorage.get('token');
     var result = yourString.slice(1,-1);
     //this.usuariolocal= result
     //const tok=this.usuariolocal
     const tok=result
      axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getUserData2.php?token='+tok)
      .then(response=>{
       
        this.usuariolocal=response.data.email
        this.unidad=response.data.unidad
        this.perfil=response.data.perfil
      })

    },
    ticketIncremento(){
       // document.getElementById('canal').value=document.getElementById('canal').value++
    this.value=Number(this.value)+1
    },
    editar(){
        document.getElementById('formPeso').empty
        this.getId()
        
           
            this.usuario()
            
             const form=document.getElementById('formPeso')
                axios.post('https://micomidasegura.mx/comidaSegura/api/crud/registrarvehiculos.php',new FormData(form))
                .then(res=>{
                    this.respuesta = res.data
                    if (res.data == 'success') {
                       // this.ticketIncremento()
                      
                       swal('Se registro el vehículo con éxito'+res.data)
                       //location.reload()
                        //this.$router.push('/inicio')
                        
                    } else {
                        swal('El vehículo no pudo ser registrado'+res.data)
                    }
                })
        },
        direccionamiento(){
            if (this.respuesta=='success') {
                this.$router.push('/')
            } else {
                swal({
                    title:'No se pudo registrar',
                    icon: 'error'})  
            }
        },
  },
  created(){
    this.ajax()
    this.usuario()
   

  },
  components:{
    Cabecera,
    Menu,
    QrcodeVue,
     QrcodeStream, 
    QrcodeDropZone, 
    QrcodeCapture 
  },
  mixins:[sesion,eliminarDecomisos]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.imagePreviewWrapper {
    width: 250px;
    height: 250px;
    display: block;
    cursor: pointer;
    margin: 0 auto 30px;
    background-size: cover;
    background-position: center center;
}

</style>



// WEBPACK FOOTER //
// src/components/Prueba.vue